import React from 'react'
import img from '../../../../public/static/image-background/logo-v-02.png'
import { formatDateTime, useTranslation, titleTemplate, getBase64 } from '../../../../constants/helpers'
import config from '../../../../constants/config'

const Mau13 = ({ dataSeason, dataSchedules, size, id, numberRound, sponsorData, isShowSponsor }) => {
    const { t } = useTranslation()
    const width = size
    const px = size / 100
    const c = {
        bg: '#f7f8fa',
        navy: '#003087',
        navyDark: '#00215c',
        red: '#e31837',
        text: '#111111',
        textSub: '#555555',
        textMuted: '#888888',
        rowBg: '#ffffff',
        rowBgAlt: '#f0f3f8',
        border: '#dde2ea',
        scoreBg: '#003087'
    }
    const classCustom = size < 1000 ? 'view' : 'export'

    return (
        <div
            id={id}
            style={{
                width: width,
                minHeight: width / 1.3,
                fontFamily: 'SFUHelveticaCondensedBold',
                backgroundColor: c.bg,
                position: 'relative',
                overflow: 'hidden'
            }}
        >
            {/* ===== HEADER NAVY BAND ===== */}
            <div style={{
                background: `linear-gradient(90deg, ${c.navyDark} 0%, ${c.navy} 60%, ${c.navyDark} 100%)`,
                padding: `${px * 2}px ${px * 3}px`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                position: 'relative',
                overflow: 'hidden'
            }}>
                {/* Diagonal stripe decoration */}
                {[...Array(6)].map((_, i) => (
                    <div key={i} style={{
                        position: 'absolute',
                        top: 0, bottom: 0,
                        left: `${10 + i * 16}%`,
                        width: `${px * 0.4}px`,
                        background: 'rgba(255,255,255,0.06)',
                        transform: 'skewX(-20deg)'
                    }} />
                ))}

                <Image src={dataSeason?.logo} style={{ width: `${px * 11}px`, height: `${px * 11}px`, objectFit: 'contain', position: 'relative', zIndex: 1 }} />

                <div style={{ flex: 1, textAlign: 'center', position: 'relative', zIndex: 1 }}>
                    <h1 style={{
                        color: '#ffffff',
                        fontSize: `${px * 4.8}px`,
                        textTransform: 'uppercase',
                        margin: 0,
                        letterSpacing: `${px * 0.4}px`
                    }}>
                        {t(titleTemplate(dataSchedules[0]?.dataGo))}
                    </h1>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: `${px * 1}px`, marginTop: `${px * 0.5}px` }}>
                        <div style={{ height: `${px * 0.2}px`, width: `${px * 8}px`, background: c.red }} />
                        <h2 style={{ color: 'rgba(255,255,255,0.85)', fontSize: `${px * 2.2}px`, textTransform: 'uppercase', margin: 0 }}>
                            {dataSeason?.name}
                        </h2>
                        <div style={{ height: `${px * 0.2}px`, width: `${px * 8}px`, background: c.red }} />
                    </div>
                    {t(numberRound) === numberRound && (
                        <div style={{
                            display: 'inline-block',
                            background: c.red,
                            color: '#fff',
                            padding: `${px * 0.3}px ${px * 2.5}px`,
                            borderRadius: `${px * 0.4}px`,
                            fontSize: `${px * 1.9}px`,
                            fontWeight: 'bold',
                            marginTop: `${px * 0.6}px`,
                            letterSpacing: '1px'
                        }}>
                            {t('round')} {numberRound}
                        </div>
                    )}
                    {t(numberRound) && t(numberRound) !== numberRound && (
                        <div style={{
                            display: 'inline-block',
                            background: c.red,
                            color: '#fff',
                            padding: `${px * 0.3}px ${px * 2.5}px`,
                            borderRadius: `${px * 0.4}px`,
                            fontSize: `${px * 1.9}px`,
                            fontWeight: 'bold',
                            marginTop: `${px * 0.6}px`,
                            letterSpacing: '1px'
                        }}>
                            {t(numberRound)}
                        </div>
                    )}
                </div>

                <Image src={img} style={{ width: `${px * 11}px`, height: `${px * 11}px`, objectFit: 'contain', position: 'relative', zIndex: 1 }} />
            </div>

            {/* ===== MATCH ROWS ===== */}
            <div style={{ padding: `${px * 1.5}px ${px * 2.5}px`, display: 'flex', flexDirection: 'column', gap: `${px * 0.8}px` }}>
                {dataSchedules[0]?.dataGo
                    ?.filter(i => i.awayTeam.name !== 'hidden' && i.homeTeam.name !== 'hidden')
                    ?.map((i, idx) => (
                        <Item key={`${idx}${new Date()}`} data={i} px={px} classCustom={classCustom} idx={idx} c={c} />
                    ))}
            </div>

            {/* ===== SPONSORS ===== */}
            {isShowSponsor && sponsorData?.length > 0 && (
                <div style={{
                    margin: `${px * 1}px ${px * 2.5}px ${px * 2}px`,
                    borderTop: `2px solid ${c.border}`,
                    paddingTop: `${px * 1.5}px`,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: `${px * 2.5}px`
                }}>
                    {sponsorData?.slice(0, 10)?.map((s, idx) => (
                        <Image key={idx} src={s.logo || config.logo} style={{ height: `${px * 5}px`, width: 'auto', objectFit: 'contain' }} />
                    ))}
                </div>
            )}

            {/* FOOTER */}
            <p style={{ textAlign: 'right', color: c.textMuted, fontSize: `${px * 1.6}px`, margin: 0, padding: `0 ${px * 2.5}px ${px * 1.5}px`, letterSpacing: '1px' }}>
                {window.sessionStorage.getItem('HomeUrl') || 'VSPORTS.VN'}
            </p>
        </div>
    )
}

// ===================== ITEM =====================
const Item = React.memo(
    ({ data, px, classCustom, idx, c }) => {
        const { t } = useTranslation()

        const arrRankName = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 'tenth']
        let teamHomeRankName = arrRankName.includes?.(data.homeTeam?.rankName) ? `${t(data.homeTeam?.rankName)}` : ''
        let teamAwayRankName = arrRankName.includes?.(data.awayTeam?.rankName) ? `${t(data.awayTeam?.rankName)}` : ''

        const arrName = ['Winquarterfinals_1', 'Winquarterfinals_2', 'Winquarterfinals_3', 'Winquarterfinals_4', 'Losesemifinal_1', 'Losesemifinal_2', 'Winsemifinal_1', 'Winsemifinal_2', 'UnknownName']

        let teamHomeName = arrName.includes(data.homeTeam?.name) || !data.homeTeam?.id ? `${t(data.homeTeam?.name) || data.homeTeam?.name}` : data.homeTeam?.name
        let teamAwayName = arrName.includes(data.awayTeam?.name) || !data.awayTeam?.id ? `${t(data.awayTeam?.name) || data.awayTeam?.name}` : data.awayTeam?.name

        let homeName = data?.homeTeam?.id ? teamHomeName : `${teamHomeRankName} ${teamHomeName}`
        let awayName = data.awayTeam?.id ? teamAwayName : `${teamAwayRankName} ${teamAwayName}`

        const isEven = idx % 2 === 0

        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                background: isEven ? c.rowBg : c.rowBgAlt,
                borderRadius: `${px * 0.5}px`,
                overflow: 'hidden',
                border: `1px solid ${c.border}`,
                minHeight: `${px * 10}px`,
                boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
            }}>
                {/* Red left accent bar */}
                <div style={{ width: `${px * 0.6}px`, alignSelf: 'stretch', background: c.red, flexShrink: 0 }} />

                {/* Time/Date */}
                <div style={{
                    minWidth: `${px * 10}px`,
                    padding: `${px * 1}px ${px * 1.5}px`,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRight: `1px solid ${c.border}`,
                    flexShrink: 0
                }}>
                    <span style={{ color: c.navy, fontSize: `${px * 2.8}px`, fontWeight: 'bold', lineHeight: 1 }}>
                        {formatDateTime(data?.dateTime, 'time')}
                    </span>
                    <span style={{ color: c.textMuted, fontSize: `${px * 1.3}px`, marginTop: `${px * 0.3}px`, textAlign: 'center', lineHeight: 1.2 }}>
                        {formatDateTime(data?.dateTime, 'date')}
                    </span>
                </div>

                {/* Home team */}
                <div style={{ flex: 2, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: `${px * 1}px`, padding: `${px * 1}px ${px * 1.5}px`, overflow: 'hidden' }}>
                    <Name
                        propClass={`home${data?.homeTeam?.id}${new Date().getTime()}${classCustom}${idx}`}
                        name={homeName} px={px} color={c.text} align="right"
                    />
                    <Image
                        src={data?.homeTeam?.logo}
                        style={{ width: `${px * 6}px`, height: `${px * 6}px`, borderRadius: '50%', objectFit: 'cover', border: `${px * 0.25}px solid ${c.navy}`, flexShrink: 0, backgroundColor: '#fff' }}
                    />
                </div>

                {/* VS / Score center */}
                <div style={{
                    minWidth: `${px * 22}px`,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                    gap: `${px * 0.4}px`
                }}>
                    {data?.isCompleted ? (
                        <>
                            <div style={{
                                background: c.scoreBg,
                                color: '#ffffff',
                                fontWeight: 900,
                                fontSize: `${px * 3.2}px`,
                                padding: `${px * 0.4}px ${px * 1.8}px`,
                                borderRadius: `${px * 0.4}px`,
                                letterSpacing: '1px',
                                whiteSpace: 'nowrap',
                                textAlign: 'center',
                                minWidth: `${px * 18}px`
                            }}>
                                {!data?.homeTeam?.isGiveUp && !data?.awayTeam?.isGiveUp && `${data?.homeTeam?.score} - ${data?.awayTeam?.score}`}
                                {data?.homeTeam?.isGiveUp && !data?.awayTeam?.isGiveUp && `0 - ${data?.awayTeam?.giveUpScore}`}
                                {!data?.homeTeam?.isGiveUp && data?.awayTeam?.isGiveUp && `${data?.homeTeam?.giveUpScore} - 0`}
                                {data?.homeTeam?.isGiveUp && data?.awayTeam?.isGiveUp && `-`}
                            </div>
                            {data?.hasPenalty && (
                                <span style={{ color: c.red, fontSize: `${px * 1.3}px`, fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                                    (PK: {data?.homeTeam?.penaltyScore} - {data?.awayTeam?.penaltyScore})
                                </span>
                            )}
                        </>
                    ) : (
                        <div style={{
                            background: `rgba(0,48,135,0.1)`,
                            border: `2px solid ${c.navy}`,
                            color: c.navy,
                            fontWeight: 900,
                            fontSize: `${px * 2.6}px`,
                            padding: `${px * 0.4}px ${px * 1.8}px`,
                            borderRadius: `${px * 0.4}px`,
                            letterSpacing: '3px',
                            whiteSpace: 'nowrap',
                            textAlign: 'center',
                            minWidth: `${px * 14}px`
                        }}>
                            VS
                        </div>
                    )}
                </div>

                {/* Away team */}
                <div style={{ flex: 2, display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: `${px * 1}px`, padding: `${px * 1}px ${px * 1.5}px`, overflow: 'hidden' }}>
                    <Image
                        src={data?.awayTeam?.logo}
                        style={{ width: `${px * 6}px`, height: `${px * 6}px`, borderRadius: '50%', objectFit: 'cover', border: `${px * 0.25}px solid ${c.border}`, flexShrink: 0, backgroundColor: '#fff' }}
                    />
                    <Name
                        propClass={`away${data?.awayTeam?.id}${new Date().getTime()}${classCustom}${idx}`}
                        name={awayName} px={px} color={c.text} align="left"
                    />
                </div>

                {/* Stadium */}
                {data?.stadium ? (
                    <div style={{ minWidth: `${px * 10}px`, maxWidth: `${px * 13}px`, padding: `${px * 1}px`, borderLeft: `1px solid ${c.border}`, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <span style={{ color: c.textMuted, fontSize: `${px * 1.3}px`, textAlign: 'center', lineHeight: 1.3 }}>
                            {data.stadium}
                        </span>
                    </div>
                ) : null}
            </div>
        )
    },
    (p, n) => JSON.stringify(p.data) === JSON.stringify(n.data)
)

// ===================== NAME =====================
const Name = React.memo(
    ({ name, px, propClass, color, align }) => {
        const reSizeBasedOnWidth = () => {
            const el = document.querySelector(`.${propClass}`)
            const container = document.querySelector(`.contain${propClass}`)
            if (!el || !container) return
            const fontSize = window?.getComputedStyle(el)?.fontSize
            el.style.fontSize = parseFloat(fontSize) - 0.25 * px + 'px'
            if (el.scrollHeight > container.clientHeight) reSizeBasedOnWidth()
        }
        const processInput = () => {
            const el = document.querySelector(`.${propClass}`)
            if (!el) return
            el.innerHTML = name
            el.style.fontSize = px * 2.6 + 'px'
            reSizeBasedOnWidth()
        }
        React.useEffect(() => { processInput() }, [name])

        return (
            <div
                className={`contain${propClass}`}
                style={{ flex: 1, height: `${px * 7}px`, display: 'flex', alignItems: 'center', justifyContent: align === 'right' ? 'flex-end' : 'flex-start', overflow: 'hidden' }}
            >
                <h2
                    className={propClass}
                    style={{ color: color, textAlign: align, textTransform: 'uppercase', margin: 0, fontWeight: 'bold', wordBreak: 'break-word', whiteSpace: 'normal', lineHeight: 1.2, fontSize: `${px * 2.6}px` }}
                />
            </div>
        )
    },
    (p, n) => JSON.stringify(p.name) === JSON.stringify(n.name)
)

// ===================== IMAGE =====================
const Image = props => {
    const [data, setData] = React.useState(null)
    React.useEffect(() => {
        if (props.src) getBase64(props.src).then(r => setData(r))
    }, [props.src])
    return <img {...props} src={data} alt="" />
}

function areEqual(p, n) {
    return JSON.stringify(p.dataSchedules) === JSON.stringify(n.dataSchedules) &&
        JSON.stringify(p.isShowSponsor) === JSON.stringify(n.isShowSponsor) &&
        JSON.stringify(p.sponsorData) === JSON.stringify(n.sponsorData)
}

export default React.memo(Mau13, areEqual)
